





























































import Vue, { PropType } from 'vue'
import { Region, VueForm, Iterable } from '@/utils/interfaces'
import { TranslateResult } from 'vue-i18n'
import { number } from '@/utils/validators'
import { Agency } from '@/api/Agency/agency.interface'
import { getAgencies } from '@/api/Agency/agency.api'
import { getRegions } from '@/api/Address/address'
import { message } from '@/store/modules/notifications'

export default Vue.extend({
  name: 'tariff-settings',
  props: {
    type: String as PropType<'CLIENT' | 'AGENCY'>,
  },
  data() {
    return {
      rules: {
        required: (v: number): TranslateResult | boolean =>
          !!v || v === 0 || this.$t('field-required'),
        number: (v: string): TranslateResult | boolean =>
          number(v) || this.$t('validation.must-be-a-number'),
      },
      crud: {
        min_commission: 0,
        percent_commission: 0,
      } as Iterable,
      regions: [] as Region[],
      defaultCrud: {},
      agencies: [] as Agency[],
      availableAgencies: [] as Agency[],
      availableRegions: [] as Region[],
      agenciesHeaders: [{ text: this.$t('agency.agency'), value: 'name' }],
      regionsHeaders: [{ text: this.$t('region'), value: 'name' }],
    }
  },
  methods: {
    onDelete(i: number) {
      this.crud.per_region.splice(i, 1)
    },
    validate() {
      if (!this.regions.length) {
        this.$store.commit('notifications/displayMessage', {
          text: this.$t('validation.region-info-is-missing'),
          title: this.$t('field-required'),
          color: 'error',
          icon: 'mdi-alert-circle',
          description: this.$t('validation.region-info-is-missing'),
        } as message)
        return false
      } else if (!this.agencies.length && this.type === 'AGENCY') {
        this.$store.commit('notifications/displayMessage', {
          text: this.$t('validation.agencies_required'),
          title: this.$t('field-required'),
          color: 'error',
          icon: 'mdi-alert-circle',
          description: this.$t('validation.agencies_required'),
        } as message)
        return false
      }
      return (this.$refs.form as VueForm).validate()
    },
    getData() {
      return {
        ...this.crud,
        regions: this.regions.map(region => region.id),
        regions_name: this.regions.map(region => region.name).join(', '),
        to_agencies: this.agencies.map(agency => agency.uuid),
        to_agencies_name: this.agencies.map(agency => agency.name).join(', '),
      }
    },
    setData(item: Iterable) {
      if (item) {
        Object.keys(this.crud).forEach(key => {
          this.crud[key] = item[key]
        })
      } else {
        this.crud = JSON.parse(JSON.stringify(this.defaultCrud))
        this.regions = []
        this.agencies = []
        ;(this.$refs.form as VueForm).resetValidation()
      }
    },
  },
  created() {
    this.defaultCrud = JSON.parse(JSON.stringify(this.crud))
  },
  mounted() {
    getAgencies({ limit: 200, not_self: true }).then(
      response => (this.availableAgencies = response.data.results),
    )
    getRegions({ limit: 20, country__name: 'Cuba' }).then(
      response => (this.availableRegions = response.data.results),
    )
  },
})
